module.exports = __webpack_public_path__ + "static/media/release.540902b7.png";